<div class="mantenedor-ayudas-page" *ngIf="isBaseRoute()">
    <div class="page-header">
        <div class="d-flex justify-content-between align-items-center">
            <div>
                <h1 class="page-title">
                    {{ isCreateRoute() ? 'CREAR AYUDA' : 'MANTENEDOR DE AYUDAS' }}
                </h1>
                <p class="page-subtitle text-muted" *ngIf="!isCreateRoute()">
                    Gestione manuales, documentos (PDF/Word) y enlaces a tutoriales de YouTube
                </p>
            </div>
            <div class="header-actions" *ngIf="!isCreateRoute()">
                <button
                    mat-raised-button
                    color="primary"
                    (click)="onCreate()"
                    matTooltip="Agregar nueva ayuda">
                    <mat-icon>add</mat-icon>
                    Nuevo
                </button>
            </div>
        </div>
    </div>

    <mat-card class="data-card">
        <mat-card-content>
            <div *ngIf="isLoading" class="loading-wrapper">
                <mat-spinner diameter="40"></mat-spinner>
            </div>
            <div class="ayudas-list-table" *ngIf="!isLoading">
                <div class="table-responsive">
                    <table mat-table [dataSource]="dataSource" matSort>
                        <ng-container matColumnDef="titulo">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="pl-0">
                                Título
                            </th>
                            <td mat-cell *matCellDef="let row" class="pl-0">
                                <div class="ayuda-info">
                                    <h6 class="mt-0 mb-0">{{ row.titulo }}</h6>
                                </div>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="tipo">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                Tipo
                            </th>
                            <td mat-cell *matCellDef="let row">
                                {{ tipoLabel(row.tipo) }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="urlOrPath">
                            <th mat-header-cell *matHeaderCellDef>
                                Enlace / Archivo
                            </th>
                            <td mat-cell *matCellDef="let row">
                                <span *ngIf="row.tipo === 'video'" class="url-text">{{ row.urlOrPath }}</span>
                                <span *ngIf="row.tipo === 'documento'"><code>{{ row.tipoDocumento || 'pdf' }}</code></span>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="estado">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                Estado
                            </th>
                            <td mat-cell *matCellDef="let row">
                                <span class="trinta-badge fw-medium d-inline-block" *ngIf="row.activo">Activo</span>
                                <span class="trinta-badge fw-medium onHand d-inline-block" *ngIf="!row.activo">Inactivo</span>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="orden">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                Orden
                            </th>
                            <td mat-cell *matCellDef="let row">{{ row.orden }}</td>
                        </ng-container>
                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef class="text-end pr-0"></th>
                            <td mat-cell *matCellDef="let row" class="text-end pr-0">
                                <div class="action">
                                    <button
                                        type="button"
                                        mat-button
                                        class="p-0 min-w-auto lh-1 h-auto"
                                        (click)="onDownload(row)"
                                        [matTooltip]="row.tipo === 'video' ? 'Abrir video' : 'Descargar'">
                                        <i class="ri-download-line" *ngIf="row.tipo === 'documento'"></i>
                                        <i class="ri-play-circle-line" *ngIf="row.tipo === 'video'"></i>
                                    </button>
                                    <button
                                        type="button"
                                        mat-button
                                        class="p-0 min-w-auto lh-1 h-auto"
                                        (click)="onEdit(row)"
                                        matTooltip="Editar">
                                        <i class="ri-edit-line"></i>
                                    </button>
                                    <button
                                        type="button"
                                        mat-button
                                        class="p-0 min-w-auto lh-1 h-auto"
                                        (click)="onDelete(row)"
                                        matTooltip="Eliminar">
                                        <i class="ri-delete-bin-line"></i>
                                    </button>
                                </div>
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let r; columns: displayedColumns"></tr>
                    </table>
                </div>
                <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]"></mat-paginator>
            </div>
        </mat-card-content>
    </mat-card>
</div>
<router-outlet></router-outlet>
